module.exports = __webpack_public_path__ + "img/24600.b2c142fe.jpg";